/**
* 左边菜单
*/ 
<template>
  <el-menu :default-active="$route.path"  :default-openeds="allmenu"  :collapse="collapsed"  router unique-opened class="el-menu-vertical-demo leftmenu" text-color="#333" active-text-color="#333">

    <el-menu-item-group class="menu-item-group-txt">
      <span slot="title"> <i class="el-icon-menu title-menu"></i> {{title}}</span>
      <el-menu-item v-for="item in allmenu" :index="'/'+item.url" :key="item.menuid">
        <i  :class="item.icon"></i>
        <span :class="menu_item_class">{{item.menuname}}</span>
      </el-menu-item>

      <!-- <el-menu-item index="/pay/Order">
        <svg t="1649945392331" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6176" width="16" height="16">
          <path d="M512.54 156.23a353.21 353.21 0 1 1-138 27.83 352.25 352.25 0 0 1 138-27.83m0-60C283.61 96.23 98 281.81 98 510.74s185.61 414.51 414.54 414.51 414.51-185.58 414.51-414.51S741.47 96.23 512.54 96.23z" p-id="6177" fill="#515151"></path>
          <path d="M512 478a29.89 29.89 0 0 1-21.13-8.71l-133-132a30 30 0 1 1 42.26-42.58l133 132A30 30 0 0 1 512 478z" p-id="6178" fill="#515151"></path>
          <path d="M512 478a30 30 0 0 1-21.21-51.21l128-128a30 30 0 0 1 42.42 42.42l-128 128A29.88 29.88 0 0 1 512 478z" p-id="6179" fill="#515151"></path>
          <path d="M660 529H366a30 30 0 0 1 0-60h294a30 30 0 0 1 0 60z m0 95H366a30 30 0 0 1 0-60h294a30 30 0 0 1 0 60z" p-id="6180" fill="#515151"></path>
          <path d="M512 776a30 30 0 0 1-30-30V448a30 30 0 0 1 60 0v298a30 30 0 0 1-30 30z" p-id="6181" fill="#515151"></path>
        </svg>

        <span :class="menu_item_class">订单管理</span>
      </el-menu-item> -->
      
    </el-menu-item-group>

  </el-menu>
</template>
<script>

export default {
  name: 'leftnav',
  props:{
  },
  data() {
    return {
      collapsed: true,
      allmenu: [],
      title: '',
      menu_item_class: ['menu-item-txt']
    }
  },
  // 创建完毕状态(里面是操作)
  created() {

    this.menuchage(this.$route,null)
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
      this.menu_item_class = ['menu-item-txt', 'pl-20']
    })
  },
  watch:{
    $route(to,from){
      
      this.menuchage(to,from)

    }
  },
  methods: {
    menuchage(to,from){
      if(to.path == '/orders' || to.path == '/product' ){
        let res = {
          success: true,
          data: [
              {
                menuid: 1,
                icon: 'el-icon-s-order',
                menuname: '订单管理',
                hasThird: 'N',
                url: 'orders',
                menus: null
              },{
                menuid: 2,
                icon: 'el-icon-menu',
                menuname: '我的服务',
                hasThird: 'N',
                url: 'product',
                menus: null
              }
          ],
          msg: 'success'
        }
        this.allmenu = res.data
        this.title = '费用'

      }else if(to.path.indexOf('personal')!=-1 ){
        let res = {
          success: true,
          data: [
              {
                menuid: 3,
                icon: 'el-icon-user-solid',
                menuname: '账号信息',
                hasThird: 'N',
                url: 'personal/user',
                menus: null
              }
          ],
          msg: 'success'
        }
        this.allmenu = res.data
        this.title = '账户中心'

      }else if(to.path.indexOf('apply')!=-1 ){
        let res = {
          success: true,
          data: [
              {
                menuid: 4,
                icon: 'el-icon-user-solid',
                menuname: '试用申请',
                hasThird: 'N',
                url: 'apply',
                menus: null
              }
          ],
          msg: 'success'
        }
        this.allmenu = res.data
        this.title = '我的申请'

      }else if(to.path.indexOf('/ai/')!=-1 ){
        let res = {
          success: true,
          data: [
              {
                menuid: 8,
                icon: 'el-icon-s-promotion',
                menuname: '发布任务',
                hasThird: 'N',
                url: 'ai/publish',
                menus: null
              },
              {
                menuid: 5,
                icon: 'el-icon-s-management',
                menuname: '关键词库',
                hasThird: 'N',
                url: 'ai/keyword',
                menus: null
              },{
                menuid: 6,
                icon: 'el-icon-s-order',
                menuname: '文章库',
                hasThird: 'N',
                url: 'ai/article',
                menus: null
              },{
                menuid: 7,
                icon: 'el-icon-s-tools',
                menuname: '发布配置',
                hasThird: 'N',
                url: 'ai/config',
                menus: null
              },{
                menuid: 9,
                icon: 'el-icon-help',
                menuname: '敏感词设置',
                hasThird: 'N',
                url: 'ai/word/sensitive',
                menus: null
              }
          ],
          msg: 'success'
        }
        this.allmenu = res.data
        this.title = '智能写作'

      }
    }
  }
}
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
  /* width: 200px;
  min-height: 400px; */
}
.menu-item-txt:not(.el-menu--collapse) {
  padding-left: 20px;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  /* background-color: #1f2d3d !important; */
}
.el-menu {
  border: none;
}

.menu-item-txt {
  /* color: rgb(213 206 206); */
  /* background-color: rgb(30, 34, 45); */
  /* font-weight: 200; */
}

.el-menu-item-group__title {
  padding-top: 20px;
  font-size: 16px;
  /* color: white;*/
}
.asideshow .el-menu-item {
  padding-left: 20px;
  padding-top: 6px;
  padding-bottom: 6px;
}
.aside .el-menu-item {
  padding-left: 17px !important;
}
.menu-item-group-txt {
  width: 200px;
}
.menu-item-group-txt .title-menu {
  margin-right: 20px;
}
.el-menu-item-group > ul {
  padding-top: 20px;
}
.menu-item-group-txt .el-menu-item:focus {
  background-color: #ffefec;
  border-left: 3px solid #c92310;
}
.menu-item-group-txt .is-active{
  background-color: #ffefec;
  border-left: 3px solid #c92310;
}
.leftmenu .menu-item-group-txt .el-menu-item:hover {
  background-color: #ffefec;
  border-left: 3px solid #c92310;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue